import type { MechKey } from './keys';

export const th: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'กลศาสตร์ · 2D',
  'panel.scene': 'ฉาก',
  'panel.dims': 'พารามิเตอร์',
  'panel.style': 'รูปลักษณ์',
  'panel.action': 'การควบคุม',
  'style.body': 'วัตถุ',
  'style.vector': 'เวกเตอร์',
  'style.ground': 'พื้น',
  'style.forces': 'แสดงแรง',
  'style.trace': 'แสดงเส้นทาง',
  'style.labels': 'ป้ายกำกับเวกเตอร์',
  'hint.line1': 'คลิกเล่นเพื่อเริ่ม · ลากวัตถุเพื่อย้าย',
  'hint.line2': 'แซนด์บ็อกซ์: เลือกรูปร่าง แล้วคลิกเพื่อวาง',
  'scene.incline': 'ระนาบเอียง',
  'scene.projectile': 'การเคลื่อนที่แบบโพรเจกไทล์',
  'scene.pendulum': 'ลูกตุ้ม',
  'scene.springMass': 'ระบบสปริง-มวล',
  'scene.collisions': 'การชน',
  'scene.atwood': 'เครื่องจักรแอตวูด',
  'scene.circular': 'การเคลื่อนที่เป็นวงกลม',
  'scene.sandbox': 'แซนด์บ็อกซ์',
  'dim.angle': 'มุม (°)',
  'dim.friction': 'แรงเสียดทาน',
  'dim.mass': 'มวล',
  'dim.massA': 'มวล A',
  'dim.massB': 'มวล B',
  'dim.velocity': 'ความเร็ว',
  'dim.angleLaunch': 'มุมยิง (°)',
  'dim.gravity': 'แรงโน้มถ่วง',
  'dim.gravityX': 'แรงโน้มถ่วง x',
  'dim.gravityY': 'แรงโน้มถ่วง y',
  'dim.length': 'ความยาว',
  'dim.damping': 'การหน่วง',
  'dim.spring': 'ความแข็ง',
  'dim.restitution': 'สัมประสิทธิ์การคืนตัว',
  'dim.radius': 'รัศมี',
  'dim.speed': 'อัตราเร็ว',
  'action.play': 'เล่น',
  'action.pause': 'หยุดชั่วคราว',
  'action.step': 'ก้าว',
  'action.reset': 'รีเซ็ต',
  'action.speed': 'ความเร็ว',
  'action.clear': 'ล้าง',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'แรงโน้มถ่วง',
  'forceName.normal': 'แรงปฏิกิริยา',
  'forceName.friction': 'แรงเสียดทาน',
  'forceName.tension': 'แรงตึง',
  'forceName.spring': 'แรงสปริง',
  'forceName.applied': 'แรงกระทำ',
  'forceName.air': 'แรงต้านอากาศ',
  'palette.box': 'กล่อง',
  'palette.circle': 'ลูกบอล',
  'palette.ramp': 'ทางลาด',
  'palette.ground': 'พื้น',
  'palette.hint': 'เลือกรูปร่าง แล้วคลิกบนผ้าใบเพื่อวาง',
  'panel.forces': 'แรงที่สังเกตเห็น',
  'forces.empty': 'ยังไม่มี — เล่นฉาก',
};
